import CryptoJS from 'crypto-js';

const SECRET_KEY = 'kaaryaalaya_v2_client_key';

const toUrlSafe = (base64) => base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');

export const encryptToUrl = (obj) => {
  const json = JSON.stringify(obj);
  const cipher = CryptoJS.AES.encrypt(json, SECRET_KEY).toString();
  return toUrlSafe(cipher);
};

export default {
  encryptToUrl,
};
